import { useEffect } from "react";
import { estimateReport, getReportDataset, listReportDatasets } from "../../api/endpoints/reportBuilder.js";
import { useReportBuilderStore } from "../stores/reportBuilderStore.js";
import { buildReportConfig } from "../services/reportBuilderSummary.js";

export function useReportBuilderBootstrap() {
  const setEstimate = useReportBuilderStore((s) => s.setEstimate);
  const setEstimateLoading = useReportBuilderStore((s) => s.setEstimateLoading);

  const datasetId = useReportBuilderStore((s) => s.datasetId);
  const filters = useReportBuilderStore((s) => s.filters);
  const session = useReportBuilderStore((s) => s.session);
  const calculatedFields = useReportBuilderStore((s) => s.calculatedFields);
  const groupBy = useReportBuilderStore((s) => s.groupBy);
  const metrics = useReportBuilderStore((s) => s.metrics);
  const filterLogic = useReportBuilderStore((s) => s.filterLogic);
  const visualization = useReportBuilderStore((s) => s.visualization);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const datasets = await listReportDatasets();
      if (cancelled) return;
      useReportBuilderStore.setState({ datasets, datasetsLoading: false });
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const ds = await getReportDataset(datasetId);
      if (!cancelled) useReportBuilderStore.setState({ activeDataset: ds });
    })();
    return () => {
      cancelled = true;
    };
  }, [datasetId]);

  useEffect(() => {
    let cancelled = false;
    setEstimateLoading(true);
    const timer = setTimeout(async () => {
      const config = buildReportConfig({
        datasetId,
        filterLogic,
        filters,
        session,
        calculatedFields,
        groupBy,
        metrics,
        visualization,
      });
      const estimate = await estimateReport(config);
      if (!cancelled) setEstimate(estimate);
    }, 180);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [datasetId, filterLogic, filters, session, calculatedFields, groupBy, metrics, visualization, setEstimate, setEstimateLoading]);
}
